var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memoize } from '@core/utils/hoc/memo.utils';
import { Checkbox as UiCheckbox } from '@headlessui/react';
import { twMerge } from 'tailwind-merge';
import { FormElementLabel } from '../forms';
var VARIANTS = {
    primary: {
        label: 'text-primary',
        checkbox: 'data-[checked]:bg-primary border-primary',
    },
    secondary: {
        label: 'text-error',
        checkbox: 'data-[checked]:bg-error border-error',
    },
    disabled: {
        label: 'opacity-50',
        checkbox: 'data-[checked]:opacity-50',
    },
};
export var Checkbox = memoize(function (_a) {
    var label = _a.label, checked = _a.checked, onChange = _a.onChange, className = _a.className, labelClassName = _a.labelClassName, wrapperClassName = _a.wrapperClassName, _b = _a.variant, variant = _b === void 0 ? 'primary' : _b, _c = _a.direction, direction = _c === void 0 ? 'column' : _c, isLoading = _a.isLoading, iconClassName = _a.iconClassName, customViewBoxStyle = _a.customViewBoxStyle, rest = __rest(_a, ["label", "checked", "onChange", "className", "labelClassName", "wrapperClassName", "variant", "direction", "isLoading", "iconClassName", "customViewBoxStyle"]);
    var renderLabel = function () {
        return (_jsx(FormElementLabel, __assign({ className: twMerge('whitespace-nowrap font-sans text-sm', VARIANTS[variant].label, rest.disabled && VARIANTS['disabled'].label, labelClassName) }, { children: label })));
    };
    return (_jsxs("div", __assign({ className: twMerge('flex', direction === 'column' ? 'flex-col' : 'flex-row items-center', wrapperClassName) }, { children: [direction === 'column' && renderLabel(), _jsx(UiCheckbox, __assign({ checked: checked, onChange: onChange, className: twMerge('group block size-4 cursor-pointer border-2 bg-white', VARIANTS[variant].checkbox, rest.disabled && VARIANTS['disabled'].checkbox, className), disabled: isLoading || rest.disabled }, rest, { children: _jsx("svg", __assign({ className: twMerge('stroke-white opacity-0 group-data-[checked]:opacity-100', iconClassName), viewBox: customViewBoxStyle || '0 0 14 14', fill: "none" }, { children: _jsx("path", { d: "M3 8L6 11L11 3.5", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }) })) })), direction === 'row' && _jsx("div", __assign({ className: "ml-2" }, { children: renderLabel() }))] })));
}, 'Checkbox');
